import { CalculusTFunction } from '@retail/calculus/i18n';
import { PriceSuggestionType } from '@retail/products/types';
import * as yup from 'yup';
import { dateRangeSchema } from '../../dateRangeSchema';
import { levelSelectSchema } from '../../CreateCondition';

export const salesPriceConditionSchema = (t: CalculusTFunction) =>
  yup
    .object({
      priceSourcePriority: yup.array<PriceSuggestionType[]>(yup.string()).default([]),
      markupCoverageDegree: yup
        .number()
        .when('priceSourcePriority', {
          is: (prio: PriceSuggestionType[]) => prio && prio.includes('MARKUP'),
          then: (coverageDegree) =>
            coverageDegree
              .typeError(t('calculus.error.mustBePercentage'))
              .transform((_, value: string | null) => {
                if (value) {
                  return Number((value + '').replace(',', '.'));
                }
                return value;
              })
              .min(-99.99, t('calculus.error.mustBeNumberBetweenZeroAndAHundred'))
              .max(99, t('calculus.error.mustBeNumberBetweenZeroAndAHundred'))
              .nullable()
              .default(null)
              .required(t('calculus.error.requiredField')),
          otherwise: (coverageDegree) =>
            coverageDegree
              .typeError(t('calculus.error.mustBePercentage'))
              .transform((_, value: string | null) => {
                if (value) {
                  return Number((value + '').replace(',', '.'));
                }
                return value;
              })
              .min(-99.99, t('calculus.error.mustBePercentage'))
              .max(99, t('calculus.error.mustBePercentage'))
              .nullable()
              .default(null)
              .optional(),
        })
        .typeError(t('calculus.error.mustBePercentage'))
        .transform((_, value: string | null) => {
          if (value) {
            return Number((value + '').replace(',', '.'));
          }
          return value;
        })
        .min(-99.99, t('calculus.error.mustBePercentage'))
        .max(90, t('calculus.error.mustBePercentage'))
        .nullable()
        .default(null)
        .optional(),
    })
    .concat(dateRangeSchema(t));

export const createSalesPriceConditionSchema = (t: CalculusTFunction, includeUnit: boolean) =>
  levelSelectSchema(t)
    .concat(salesPriceConditionSchema(t))
    .concat(
      yup.object({
        gtin: includeUnit
          ? yup
              .string()
              .default('')
              .when('level', {
                is: 'item',
                then: yup.string().default('').required(t('calculus.error.unit')),
              })
          : yup.string(),
      })
    )
    .concat(dateRangeSchema(t));

export type SalesPriceConditionSchema = yup.InferType<ReturnType<typeof salesPriceConditionSchema>>;

export type CreateSalesPriceConditionSchema = yup.InferType<
  ReturnType<typeof createSalesPriceConditionSchema>
>;
